import React from 'react';
import Text from '../Base/Text/Text';
import { joinClasses } from '../../Utils/className.util';
import { Theme } from '../../Enums/Theme.enum';

// @ts-ignore
import styles from './Buttons.module.scss';
import Loading, { LoadingSize } from '../Loading';

interface LinkButtonProps {
	onClick?: () => void;
	href?: string;
	title: string;
	theme: Theme;
	className?: string;
	firstUpper?: boolean;
	disabled?: boolean;
	isLoading?: boolean;
	displayAsButton?: boolean;
	style?: React.CSSProperties;
	fitContent?: boolean;
}

export default function LinkButton(props: LinkButtonProps) {
	const {
		onClick,
		title,
		theme,
		href,
		className,
		firstUpper,
		disabled = false,
		isLoading = false,
		displayAsButton = false,
		fitContent = false,
		style,
	} = props;

	const handlePress = () => {
		if (disabled) {
			return;
		}
		onClick?.();
	};

	const classes = joinClasses([
		displayAsButton ? styles.button : styles.linkButton,
		styles[theme],
		className,
		disabled ? styles.disabled : '',
		fitContent ? styles.fitContent : '',
	]);
	const content = (
		<Text
			className={styles.title}
			tx={title}
			inline={true}
			firstUpper={firstUpper}
			style={style}
		/>
	);

	if (isLoading) {
		return <Loading size={LoadingSize.SMALL} />;
	}

	if (href) {
		return (
			<a
				className={classes}
				href={href}
				target='_blank'
				style={style}
				onClick={handlePress}>
				{content}
			</a>
		);
	}

	return (
		<div className={classes} onClick={handlePress} style={style}>
			{content}
		</div>
	);
}
